import { render, staticRenderFns } from "./ModalPublishPayslips.vue?vue&type=template&id=3dd5d1b2"
import script from "./ModalPublishPayslips.vue?vue&type=script&lang=js"
export * from "./ModalPublishPayslips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dd5d1b2')) {
      api.createRecord('3dd5d1b2', component.options)
    } else {
      api.reload('3dd5d1b2', component.options)
    }
    module.hot.accept("./ModalPublishPayslips.vue?vue&type=template&id=3dd5d1b2", function () {
      api.rerender('3dd5d1b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Payslips/ModalPublishPayslips.vue"
export default component.exports